import styled from 'styled-components'
import { fleetColors } from '../FleetOverview/FleetOverview.styled'

export { fleetColors }

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
`

export const TitleBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  .back {
    background: transparent;
    border: none;
    cursor: pointer;
    color: ${({ theme }) => theme.textColor};
    display: flex;
    align-items: center;
    padding: 4px;
    border-radius: 6px;

    &:hover {
      background: rgba(255, 255, 255, 0.05);
    }
  }
`

export const TopRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

export const StatusPill = styled.span<{ tone: 'success' | 'warning' | 'danger' }>`
  padding: 5px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid
    ${({ tone, theme }) =>
      tone === 'success'
        ? theme.colorGreen
        : tone === 'warning'
          ? theme.colorOrange
          : theme.colorRed};
  color: ${({ tone, theme }) =>
    tone === 'success'
      ? theme.colorGreen
      : tone === 'warning'
        ? theme.colorOrange
        : theme.colorRed};
`

export const RangeBtns = styled.div`
  display: flex;
  gap: 6px;
  margin-left: auto;
`

export const RangeBtn = styled.button<{ active?: boolean }>`
  background: ${({ active, theme }) => (active ? theme.colorOrange : 'transparent')};
  color: ${({ active, theme }) => (active ? '#101010' : theme.textColor)};
  border: 1px solid ${({ active, theme }) => (active ? theme.colorOrange : fleetColors.divider)};
  border-radius: 8px;
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
`

export const Grid4 = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
`

export const Grid5 = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
`

export const MetricCard = styled.div<{ accent?: string }>`
  background: ${fleetColors.cardSurface};
  border: 1px solid ${fleetColors.divider};
  border-left: 3px solid ${({ accent, theme }) => accent || theme.colorOrange};
  border-radius: 10px;
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  backdrop-filter: blur(8px);
`

export const MetricValue = styled.div<{ accent?: string }>`
  font-size: 28px;
  font-weight: 800;
  color: ${({ accent, theme }) => accent || theme.textColor};
  line-height: 1;
`

export const Split = styled.div<{ cols?: string }>`
  display: grid;
  grid-template-columns: ${(p) => p.cols || '1fr 1fr'};
  gap: 1rem;
  margin-bottom: 1rem;
`

export const Panel = styled.div<{ accent?: string }>`
  background: ${fleetColors.cardSurface};
  border: 1px solid ${(p) => p.accent || fleetColors.divider};
  border-radius: 12px;
  padding: 1.25rem;
  backdrop-filter: blur(8px);
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const InfoPairGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem 1.5rem;
  margin-bottom: 1rem;

  .col-value {
    display: flex;
    align-items: center;
    gap: 6px;

    svg {
      color: ${({ theme }) => theme.colorOrange};
      width: 16px;
      height: 16px;
    }
  }

  .telemetry {
    color: ${({ theme }) => theme.colorGreen};
    font-weight: 600;
  }
`

export const FuelBar = styled.div`
  margin-top: 6px;
  height: 8px;
  background: ${fleetColors.trackBg};
  border-radius: 4px;
  overflow: hidden;
`

export const FuelFill = styled.div<{ width: number }>`
  width: ${(p) => p.width}%;
  height: 100%;
  background: ${({ theme }) => theme.colorOrange};
`

export const StateGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  margin-top: 0.75rem;
`

export const StateTile = styled.div`
  background: ${fleetColors.cardInner};
  border: 1px solid ${fleetColors.divider};
  border-radius: 10px;
  padding: 0.85rem 1rem;
`

export const RegTable = styled.div`
  .row {
    display: flex;
    justify-content: space-between;
    padding: 0.65rem 0;
    border-bottom: 1px solid ${fleetColors.divider};
  }

  .row:last-child {
    border-bottom: none;
  }
`

export const ChartBox = styled.div`
  position: relative;
  height: 180px;
  padding-top: 0.5rem;
`

export const ChartBars = styled.div`
  position: absolute;
  inset: 0.5rem 0 1.5rem 0;
  display: flex;
  align-items: flex-end;
  gap: 4px;
`

export const Bar = styled.div<{ h: number; color: string; muted?: boolean }>`
  flex: 1;
  height: ${(p) => p.h}%;
  background: ${(p) => (p.muted ? p.color + '60' : p.color)};
  border-radius: 2px;
`

export const ChartFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
`

export const TargetChip = styled.span<{ color?: string }>`
  border: 1px solid ${(p) => p.color || p.theme.colorOrange};
  color: ${(p) => p.color || p.theme.colorOrange};
  border-radius: 6px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 600;
`

export const OpTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  thead th {
    text-align: left;
    font-size: 11px;
    letter-spacing: 0.08em;
    color: ${({ theme }) => theme.textFaded};
    font-weight: 700;
    padding: 0.75rem 0.75rem;
    text-transform: uppercase;
    border-bottom: 1px solid ${fleetColors.divider};
  }

  tbody td {
    padding: 0.85rem 0.75rem;
    border-bottom: 1px solid ${fleetColors.divider};
    color: ${({ theme }) => theme.textColor};
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  .op-cell {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: ${fleetColors.cardInner};
    border: 1px solid ${fleetColors.divider};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colorOrange};
    font-size: 12px;
    font-weight: 700;
  }

  .incident {
    font-size: 11px;
    color: ${({ theme }) => theme.colorRed};
    margin-top: 2px;
  }
`

export const SignalBox = styled.div`
  margin-top: 0.75rem;
  padding: 0.9rem 1rem;
  border-left: 3px solid ${({ theme }) => theme.colorGreen};
  background: ${fleetColors.cardInner};
  border-radius: 8px;
  line-height: 1.5;

  .label {
    color: ${({ theme }) => theme.colorGreen};
    font-weight: 700;
  }

  .hl-green {
    color: ${({ theme }) => theme.colorGreen};
    font-weight: 700;
  }

  .hl-orange {
    color: ${({ theme }) => theme.colorOrange};
    font-weight: 700;
  }
`

export const ScrollIndicator = styled.div`
  height: 4px;
  border-radius: 2px;
  background: ${fleetColors.trackBg};
  overflow: hidden;
  margin-top: 0.75rem;
`

export const ScrollFill = styled.div<{ w: number }>`
  width: ${(p) => p.w}%;
  height: 100%;
  background: ${({ theme }) => theme.colorOrange};
`

export const StackedBar = styled.div`
  display: flex;
  height: 12px;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 1rem;
`

export const StackedSeg = styled.div<{ w: number; color: string }>`
  width: ${(p) => p.w}%;
  background: ${(p) => p.color};
`

export const LegendList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .li {
    display: grid;
    grid-template-columns: 1fr auto auto;
    gap: 0.75rem;
    align-items: center;
    font-size: 13px;
  }

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 2px;
  }

  .name {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme.textColor};
  }

  .pct {
    color: ${({ theme }) => theme.textColor};
    font-weight: 700;
    min-width: 32px;
    text-align: right;
  }
`

export const BenchList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`

export const BenchRow = styled.div<{ positive?: boolean }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  align-items: center;

  .v {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.5rem;
    font-size: 13px;
    color: ${({ theme }) => theme.textColor};
  }

  .num {
    font-weight: 700;
  }

  .delta {
    color: ${(p) => (p.positive ? p.theme.colorGreen : p.theme.colorRed)};
    font-weight: 700;
    font-size: 12px;
  }
`

export const FuelMetricsPanel = styled(Panel)`
  border: 1px solid ${({ theme }) => theme.colorOrange};
`

export const FuelTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;

  .icon {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid ${fleetColors.divider};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colorOrange};
  }

  .src {
    border: 1px solid ${({ theme }) => theme.colorOrange};
    color: ${({ theme }) => theme.colorOrange};
    padding: 3px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
  }
`

export const FuelMetricGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1rem;
`

export const FuelMetricItem = styled.div`
  .value {
    font-size: 22px;
    font-weight: 800;
    color: ${({ theme }) => theme.textColor};
    margin-top: 6px;
  }

  .green {
    color: ${({ theme }) => theme.colorGreen};
  }

  .orange {
    color: ${({ theme }) => theme.colorOrange};
  }
`

export const BoundaryNote = styled.div`
  margin-top: 1rem;
  padding: 0.9rem 1rem;
  background: ${fleetColors.cardInner};
  border-radius: 8px;
  line-height: 1.5;

  .strong {
    color: ${({ theme }) => theme.textColor};
    font-weight: 700;
  }
`

export const CostEfficiencyBox = styled.div`
  background: ${fleetColors.cardInner};
  border: 1px solid ${fleetColors.divider};
  border-radius: 10px;
  padding: 1rem 1.25rem;
  margin-top: 1rem;

  .ce-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 0.5rem 0;
  }

  .ce-v {
    color: ${({ theme }) => theme.colorGreen};
    font-weight: 700;
  }
`

export const CostBarStacked = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0.5rem 0;

  .top {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }

  .amt {
    display: inline-flex;
    gap: 8px;
    color: ${({ theme }) => theme.textColor};
    font-weight: 700;
    font-size: 14px;
  }

  .pct {
    color: ${({ theme }) => theme.textFaded};
    font-weight: 500;
    font-size: 12px;
  }
`

export const CostTrack = styled.div`
  height: 6px;
  background: ${fleetColors.trackBg};
  border-radius: 3px;
  overflow: hidden;
`

export const CostFill = styled.div<{ w: number; color: string }>`
  width: ${(p) => p.w}%;
  height: 100%;
  background: ${(p) => p.color};
`
